<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <form class="form form-vertical row" [formGroup]="formGroup" (ngSubmit)="sendDocument()">
        <core-card [actions]="[]" class="col-12">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="title">{{ "TITLE_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="title" class="form-control font-medium-4 {{ fieldHasErrors('title') ? 'is-invalid' : '' }}" formControlName="title" />
                <div class="invalid-feedback" *ngIf="formGroup.controls.title.errors?.required">{{ "ERRORS.INSERT_TITLE" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.title?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.title?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12">
                <label for="category">{{ "CATEGORY_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  formControlName="category"
                  id="category"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  class="{{ fieldHasErrors('category') ? 'is-invalid' : '' }}"
                >
                  <ng-option *ngFor="let cat of categoriesList" [value]="cat.id">{{ cat.parent_id ? "&#8211;" : "" }} {{ cat.name }}</ng-option>
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.category.errors?.required">{{ "ERRORS.FIELD_CATEGORY_DOCUMENT" | translate }}</div>
              </div>
              <div class="form-group col-xl-6 col-md-6 col-12" [ngClass.xl]="'mb-0'" *ngIf="!sendToEveryone">
                <label for="send_to_users">{{ "SEND_EMPOLYEE_COMMUNICATION" | translate }}:</label>
                <!-- avatar group with tooltip -->
                <div>
                  <ng-select
                    (change)="changeDestination('users'); timeToProcessFiles()"
                    id="send_to_users"
                    formControlName="send_to_users"
                    [searchable]="true"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    [multiple]="true"
                  >
                    <ng-option *ngFor="let users of users_list" [value]="users.hash">
                      <span class="font-small-4 font-weight-normal">{{ users.firstname }} {{ users.lastname }}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <!--
                             <div class="form-group col-xl-3 col-md-6 col-12" [ngClass.xl]="'mb-0'" *ngIf="!sendToEveryone">
                                <label for="send_to_groups">{{"SEND_GROUP_COMMUNICATION" | translate}}:</label>
                                <div>
                                    <ng-select (change)="changeDestination('groups');timeToProcessFiles()"
                                               id="send_to_groups" formControlName="send_to_groups"
                                               [searchable]="true" [closeOnSelect]="true" [clearable]="false"
                                               [openOnEnter]="false" [virtualScroll]="true"
                                               [multiple]="true">
                                        <ng-option *ngFor="let group of group_list" [value]="group.id">
                                            <span class="font-small-4 font-weight-normal">{{group.name}}</span>
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div> 
                            -->
              <div class="form-group col-xl-6 col-md-12 col-12">
                <label for="basicTextarea">{{ "DESCRIPTION" | translate }}:<sup class="text-danger">*</sup></label>
                <textarea class="form-control {{ fieldHasErrors('description') ? 'is-invalid' : '' }}" id="basicTextarea" rows="3" formControlName="description"> </textarea>
                <div class="invalid-feedback" *ngIf="formGroup.controls.description.errors?.required">{{ "ERRORS.FIELD_DESCRIPTION" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-xl-3 col-md-6" *ngIf="!sendNow" [ngClass.sm]="'col-7'">
                <div class="form-group" *ngIf="basicDateOptions">
                  <label for="send_date">{{ "SEND_DATE" | translate }}:<sup class="text-danger">*</sup></label>
                  <ng2-flatpickr id="send_date" (change)="handlerChangeData($event); timeToProcessFiles()" [ngClass]="'firstsecond'" [config]="basicDateOptions" formControlName="send_date"> </ng2-flatpickr>
                </div>
              </div>
              <div class="form-group col-xl-3 col-md-6" *ngIf="!sendNow" [ngClass.sm]="'col-5'">
                <label for="time">{{ "HOUR_TO" | translate }}:<sup class="text-danger">*</sup></label>
                <ngb-timepicker id="time" formControlName="time" [spinners]="false"></ngb-timepicker>
              </div>
              <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="!showEditor">
                <fieldset>
                  <label for="fileDocument">{{ "INSERT.UPLOAD_DOCUMENT" | translate }}:<sup class="text-danger">*</sup></label>
                  <div class="custom-file">
                    <input
                      class="custom-file-input {{ fieldHasErrors('file') ? 'is-invalid' : '' }}"
                      type="file"
                      lang="it"
                      id="fileDocument"
                      formControlName="file"
                      accept="application/pdf"
                      (change)="handlerChangeFileInput($event)"
                    />
                    <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                    <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.file.errors?.required">{{ "ERRORS.INSERT_FILE" | translate }}</div>
                  </div>
                </fieldset>
              </div>
              <div class="form-group col-xl-2 col-md-6 col-12" *ngIf="requireAcception || requireSignature">
                <div class="form-group" *ngIf="basicDateOptions">
                  <label for="end_date">{{ "EXPIRE_DATE" | translate }}:<sup class="text-danger">*</sup></label>
                  <ng2-flatpickr id="end_date" (change)="handlerChangeDataExpire($event)" [ngClass]="'firstsecond'" [config]="basicDateOptions" formControlName="end_date"> </ng2-flatpickr>
                </div>
              </div>
              <div class="form-group col-xl-12 col-md-12 col-12 d-flex" [ngClass.sm]="'row'" [ngClass.md]="'row'">
                <div class="custom-control custom-control-primary custom-switch mr-1" [ngClass.sm]="'ml-2 mb-1'" [ngClass.md]="'ml-2 mb-1'">
                  <small class="mr-025">{{ "CREATE_DOCUMENT" | translate }}</small>
                  <input (change)="timeToProcessFiles()" type="checkbox" class="custom-control-input" id="showEditor" [ngModelOptions]="{ standalone: true }" [(ngModel)]="showEditor" />
                  <label class="custom-control-label" for="showEditor"> </label>
                </div>
                <div class="custom-control custom-control-primary custom-switch mr-1" [ngClass.sm]="'col-12 ml-2 mb-1'" [ngClass.md]="'col-12 ml-2 mb-1'">
                  <small class="mr-025">{{ "SEND_ALL_EMPLOYEE" | translate }}</small>
                  <input (change)="changeDestination('all'); timeToProcessFiles()" type="checkbox" class="custom-control-input" id="sendToEveryone" [ngModelOptions]="{ standalone: true }" [(ngModel)]="sendToEveryone" />
                  <label class="custom-control-label" for="sendToEveryone"> </label>
                </div>
                <div class="custom-control custom-control-primary custom-switch mr-1" [ngClass.sm]="'col-12 ml-2 mb-1'" [ngClass.md]="'col-12 ml-2 mb-1'">
                  <small class="mr-025">{{ "REQUIRE_SIGNATURE" | translate }}</small>
                  <input (ngModelChange)="requireAlsoAcception()" type="checkbox" class="custom-control-input" id="requireSignature" [ngModelOptions]="{ standalone: true }" [(ngModel)]="requireSignature" />
                  <label class="custom-control-label" for="requireSignature"> </label>
                </div>
                <div class="custom-control custom-control-primary custom-switch mr-1" [ngClass.sm]="'col-12 ml-2 mb-1'" [ngClass.md]="'col-12 ml-2 mb-1'">
                  <small class="mr-025">{{ "REQUIRE_ACCEPTION" | translate }}</small>
                  <input [attr.disabled]="requireSignature ? true : null" type="checkbox" class="custom-control-input" id="requireAcception" [ngModelOptions]="{ standalone: true }" [(ngModel)]="requireAcception" />
                  <label class="custom-control-label" for="requireAcception"> </label>
                </div>
                <div class="custom-control custom-control-primary custom-switch" [ngClass.sm]="'col-12 ml-2 mb-1'" [ngClass.md]="'col-12 ml-2 mb-1'">
                  <small class="mr-025">{{ "SEND_NOW" | translate }}</small>
                  <input type="checkbox" class="custom-control-input" id="sendNow" [ngModelOptions]="{ standalone: true }" [(ngModel)]="sendNow" (change)="timeToProcessFiles()" />
                  <label class="custom-control-label" for="sendNow"> </label>
                </div>
              </div>
              <div class="form-group col-xl-12 col-md-12 col-12" *ngIf="showEditor">
                <div class="row">
                  <div class="col-xl-9 col-md-12 col-12">
                    <label for="text">{{ "MESSAGGE" | translate }}:<sup class="text-danger">*</sup></label>
                    <angular-editor id="text" [config]="_utilService.defaultEditorConfig" [formControlName]="'text'" class="{{ fieldHasErrors('text') ? 'is-invalid' : '' }}"></angular-editor>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.text.errors?.required">{{ "ERRORS.INSERT_MESSAGE" | translate }}</div>
                    <div class="invalid-feedback" *ngIf="formGroup.controls?.text?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                  </div>
                  <div class="legend" ngClass.xl="col-xl-3" ngClass.sm="mt-1 col-12" ngClass.md="mt-1 col-12">
                    <label>{{ "LEGEND" | translate }}:</label>
                    <app-replace-field-list></app-replace-field-list>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <div class="mb-075" *ngIf="approximateTimeProcess && timeToProcess">
              {{ "TIME_PROCESS_CREATE_DOCUMENT" | translate }} {{ approximateTimeProcess }} {{ approximateTimeProcess === 1 ? ("MINUTE" | translate) : ("MINUTES" | translate) }}
            </div>
            <button (click)="setLocalStorage()" target="_blank" type="button" rippleEffect *ngIf="showEditor" class="btn btn-outline-secondary mr-1">{{ "PREVIEW" | translate }}</button>
            <button routerLink="/dashboard/documents-list" type="button" rippleEffect class="btn btn-outline-secondary mr-1">{{ "BACK" | translate }}</button>
            <button (click)="sendDocument()" type="button" rippleEffect class="btn btn-primary" *ngIf="_authenticationService.hasCapability('create_document')">{{ "SAVE" | translate }}</button>
          </div>
        </core-card>
      </form>
    </section>
  </div>
</div>
